/**
 * 搜索缓存 Key 枚举
 *
 * 定义所有可用的搜索缓存键名，确保类型安全和统一管理
 */
export const SearchCacheKey = {
    /** 专利撰写 - 技术交底书缓存 */
    PATENT_DISCLOSURE: 'eureka-ip:patent-disclosure-cache',
    /** 专利撰写 - 权利要求缓存 */
    PATENT_CLAIMS: 'eureka-ip:patent-claims-cache',
    /** FTO 检索输入缓存 */
    FTO_SEARCH: 'eureka-ip:fto-search-cache',
    /** 新颖性检索输入缓存 */
    NOVELTY_SEARCH: 'eureka-ip:novelty-search-cache',
} as const;

/**
 * 搜索缓存 Key 类型
 */
export type SearchCacheKeyType = typeof SearchCacheKey[keyof typeof SearchCacheKey];

/**
 * 缓存恢复服务
 *
 * 负责从存储中恢复缓存数据，恢复后立即清除缓存，确保一次性使用语义
 */
export interface CacheRestoreService {
    /**
     * 从存储中恢复字符串值，恢复后清除缓存
     *
     * @param cacheKey - 缓存键名
     * @returns 缓存的值，如果不存在则返回空字符串
     */
    restore(cacheKey: string): string;

    /**
     * 批量恢复多个缓存值
     *
     * @param cacheKeys - 缓存键名数组
     * @returns 按照输入顺序返回的缓存值数组
     */
    restoreMultiple(cacheKeys: string[]): string[];
}

export const CacheRestoreService = Symbol.for('CacheRestoreService');
